module.exports = __webpack_public_path__ + "static/img/10.d1bbaac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/10.jpg
// module id = nLqa
// module chunks = 0